The email address that candidate applications are directed to.

Do not select this in your operations,
or your integration will break when the field is removed.
